import { render } from "./DeliveryBlock.vue?vue&type=template&id=24b90566&scoped=true"
import script from "./DeliveryBlock.vue?vue&type=script&lang=js"
export * from "./DeliveryBlock.vue?vue&type=script&lang=js"

import "./DeliveryBlock.vue?vue&type=style&index=0&id=24b90566&scoped=true&lang=css"
import "./DeliveryBlock.vue?vue&type=style&index=1&id=24b90566&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b90566"]])

export default __exports__